import React, { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as styles from './TermsOfService.module.css';
import backIcon from 'url:../../assets/images/back-icon-black.webp';

import SEO from 'src/components/SEO';

export const TermsOfService: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Terms of Service - miniPT"
        description="miniPT terms of service and usage conditions."
        canonicalUrl="/terms-of-service"
      />
      <div className={styles.page}>
        <button className={styles.backButton} onClick={() => navigate(-1)}>
          <img src={backIcon} alt="Back" className={styles.backIcon} />
          <div className={styles.backButtonText}>Back</div>
        </button>

        <div className={styles.title}>MiniPT Terms of Service</div>

        <p className={styles.date}>Effective Date: January 16, 2026</p>

        <h3>1. Introduction</h3>
        <p>
          1.1 MiniPT is a fitness company that provides a mobile application (the &#34;App&#34;) to
          allowing them to access a range of fitness and health-related services.
        </p>
        <p>
          1.2 These terms and conditions (the &#34;Terms&#34;) govern your use of the App and any
          related services provided by MiniPT. By accessing or using the App, you agree to be bound
          by these Terms. If you do not agree with these Terms, you must not use the App.
        </p>

        <h3>2. Data Collection</h3>
        <p>
          2.1 MiniPT may collect and use your personal data, which is defined as any information
          that can be used to identify you as an individual. This includes, but is not limited to:
        </p>
        <p>
          - Your name, age, gender, and contact details (e.g. email address, phone number)
          <br />
          - Your fitness and health-related data, such as your weight, height, body mass index
          (BMI), exercise routines, and nutrition plans
          <br />
          - Your location data, if you choose to enable location services on the App
          <br />- Information provided by you through text fields, your interaction with the MiniPT
          chatbot (MPTChat) messaging system, and other data.
        </p>

        <h3>3. Data Collection</h3>
        <p>
          3.1 MiniPT may collect and use your personal data, such as information provided by you
          through text fields, your interaction with the MiniPT chatbot (MPTChat) messaging system,
          your location data and other data, in accordance with MiniPT&#39;s Privacy Policy, which
          is available on the App and on the MiniPT website.
        </p>
        <p>
          3.2 You agree to provide MiniPT with accurate, complete and up-to-date information and to
          keep such information updated.
        </p>

        <h3>4. Intellectual Property</h3>
        <p>
          4.1 All intellectual property rights in the App and related services, including but not
          limited to copyrights, trademarks, patents and trade secrets, are owned by MiniPT or its
          licensors. You may not use any MiniPT content for commercial purposes or for any other
          unauthorized purpose.
        </p>

        <h3>5. Disclaimer of Warranties</h3>
        <p>
          5.1 MiniPT provides the App and related services on an &#34;as is&#34; and &#34;as
          available&#34; basis and makes no representations or warranties of any kind, express or
          implied, as to the operation of the App or the information, content, materials, or
          products included on the App.
        </p>
        <p>
          5.2 MiniPT does not warrant that the App will be uninterrupted or error-free, and MiniPT
          will not be liable for any interruptions or errors.
        </p>

        <h3>6. Limitation of Liability</h3>
        <p>
          6.1 In no event will MiniPT be liable for any damages, including but not limited to
          indirect, incidental, special, punitive or consequential damages, arising out of the use
          of or inability to use the App or any information, content, materials, products or
          services available through the App, even if MiniPT has been advised of the possibility of
          such damages.
        </p>

        <h3>7. Indemnification</h3>
        <p>
          7.1 You agree to indemnify and hold MiniPT, its affiliates, officers, agents, and
          employees harmless from any claim or demand, including reasonable attorney&#39;s fees,
          made by any party due to or arising out of your use of the App or violation of these
          Terms.
        </p>

        <h3>8. Termination</h3>
        <p>
          8.1 MiniPT may, in its sole discretion, at any time terminate or suspend all or a portion
          of the App or your use of all or a portion of the App, with or without notice and with or
          without cause.
        </p>

        <h3>9. Governing Law</h3>
        <p>
          9.1 These Terms shall be governed by and construed in accordance with the laws of England
          and Wales, without giving effect to any principles of conflicts of law.
        </p>

        <h3>10. General</h3>
        <p>
          10.1 These Terms constitute the entire agreement between you and MiniPT with respect to
          the use of the App and supersede all prior agreements and understandings between you and
          MiniPT, whether written or oral, relating to the use of the App.
        </p>
        <p>
          10.2 If any provision of these Terms is found to be invalid or unenforceable, such
          provision shall be severed from these Terms, and the remaining provisions shall remain in
          full force and effect.
        </p>

        <h3>11. Contact</h3>
        <p>
          11.1 If you have any questions or concerns about these Terms or the App, please contact
          MiniPT at <a href="mailto:Samuel@minipt.co.uk">Samuel@minipt.co.uk</a>,{' '}
          <strong>Onega House, 112 Main Road, Sidcup, Kent, DA14 6NE, UK, 07393207131.</strong>
        </p>

        <h3>12. Changes to Terms</h3>
        <p>
          12.1 MiniPT may make changes to these Terms from time to time. The updated version of
          these Terms will be posted on the App and/or the MiniPT website. Your continued use of the
          App after such changes constitutes your acceptance of the new Terms.
        </p>

        <h3>13. Assignment</h3>
        <p>
          13.1 You may not assign these Terms or transfer any rights to use the App without the
          prior written consent of MiniPT. MiniPT may assign these Terms or transfer any rights to
          use the App without your prior written consent.
        </p>

        <h3>14. Third-Party Services</h3>
        <p>
          14.1 The App may contain links to third-party websites or services that are not owned or
          controlled by MiniPT. MiniPT has no control over and assumes no responsibility for, the
          content, privacy policies, or practices of any third-party websites or services. You
          acknowledge and agree that MiniPT shall not be responsible or liable, directly or
          indirectly, for any damage or loss caused or alleged to be caused by or in connection with
          the use of or reliance on any such content, goods, or services available on or through any
          such websites or services.
        </p>

        <h3>15. User Conduct</h3>
        <p>
          15.1 You agree to use the App in accordance with all applicable laws and regulations and
          in a manner that does not violate the rights of MiniPT or any third party. You may not use
          the App to engage in any illegal or unauthorized activity, including but not limited to:
        </p>
        <p>
          a. uploading, posting, or transmitting any content that is illegal, obscene, defamatory,
          threatening, harassing, hateful, or offensive;
        </p>
        <p>
          b. impersonating any person or entity or falsely stating or otherwise misrepresenting your
          affiliation with a person or entity;
        </p>
        <p>
          c. accessing or attempting to access the App by any means other than through the interface
          provided by MiniPT;
        </p>
        <p>
          d. attempting to interfere with, compromise the system integrity or security, or decipher
          any transmissions to or from the servers running the App;
        </p>
        <p>
          e. taking any action that imposes, or may impose, at MiniPT&#39;s sole discretion, an
          unreasonable or disproportionately large load on MiniPT&#39;s infrastructure;
        </p>
        <p>f. uploading invalid data, viruses, worms, or other software agents through the App;</p>
        <p>
          g. collecting or harvesting any personally identifiable information, including account
          names, from the App;
        </p>
        <p>h. using the App for any commercial solicitation purposes.</p>

        <h3>16. Dispute Resolution</h3>
        <p>
          16.1 If a dispute arises between you and MiniPT, you agree first to contact MiniPT and
          attempt to resolve the dispute informally. If the dispute cannot be resolved informally,
          the parties agree to resolve the dispute through binding arbitration in accordance with
          the rules of the American Arbitration Association.
        </p>

        <h3>17. Agreement to Electronic Communication</h3>
        <p>
          17.1 By using the App, you consent to receive electronic communications from MiniPT. These
          communications may include notices about your account and information and updates
          concerning the App and related services.
        </p>

        <h3>18. No Waiver</h3>
        <p>
          18.1 MiniPT&#39;s failure to enforce any right or provision in these Terms shall not
          constitute a waiver of such right or provision unless acknowledged and agreed to by MiniPT
          in writing.
        </p>

        <p>
          These Terms and Conditions of Use represent the entire understanding between you and
          MiniPT regarding the use of the MiniPT App and related services and supersedes all prior
          agreements and understandings, whether written or oral, relating to the use of the MiniPT
          App and related services.
        </p>

        <p>
          By using the MiniPT App and related services, you agree to be bound by these Terms and
          Conditions. If you do not agree to these Terms and Conditions, you must not use the MiniPT
          App and related services.
        </p>

        <p>
          <a
            href="https://www.notion.so/Whoop-1e773cfa3b044ef6ab88f4b006ba1697?pvs=21"
            target="_blank"
            rel="noopener noreferrer"
          >
            Whoop
          </a>
        </p>
        <p>
          <a
            href="https://www.notion.so/Pelaton-dddda32025e341b889d8d2e6201b4b18?pvs=21"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pelaton
          </a>
        </p>
      </div>
    </>
  );
};

export default TermsOfService;
